import ApiService from "@/core/services/api.service";

// action types
export const SEND_EMAIL = "sendEmail";

// mutation types
export const SET_EMAIL = "setEmail";
export const SET_ORDERS = "setOrders";
export const SET_ORDER = "setOrder";
export const SET_DETAILS = "setDetails";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  conciliaciones: [],
  methods: [],
  orders: [],
  order: null,
};

const actions = {
  [SEND_EMAIL](context, user) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post(
        { action: `/facturacioncomisionapi/api/NotificarAsignacion/v1/notificar/` },
        user
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data);
          reject(response);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_EMAIL](state, email) {
    state.error = {};
    state.email = email;
  },
  [SET_ORDERS](state, orders) {
    state.error = {};
    state.orders = orders;
  },
  [SET_DETAILS](state, details) {
    state.error = {};
    state.details = details;
  },
  [SET_ORDER](state, data) {
    state.error = {};
    state.order = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
